import { render, staticRenderFns } from "./FormUserManage.vue?vue&type=template&id=99a5c6d4"
import script from "./FormUserManage.vue?vue&type=script&lang=js"
export * from "./FormUserManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports